export class HousingFinanceAgenciesApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getHousingFinanceAgencies({ state, ...params } = {}) {
    return this.#http.get('/api/housing-finance-agencies', { params: { state, ...params } });
  }
}
